export function numberWithCommas(x) {
    if(x == null) return "";
    let num = x.toString();
    let strArray = num.split('.');
    if(strArray.length > 1) {
      return strArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + strArray[1];
    } else {
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
export function mathFloor(x) {
    if(x == null) return "";
    x = Math.floor(x * 1000000);
    return x / 1000000;
}
